import type { DetailPageTab } from "src/components/layout/detail-page";

/** The agent settings pages, as the page's tabs or, with the product tabs, entries in the settings sidebar. */
export const AGENT_SETTINGS_TABS: DetailPageTab[] = [
  {
    title: "General",
    path: "general",
    variant: "form",
    hasBottomPadding: true,
  },
  {
    title: "Connectors",
    path: "connectors",
    variant: "form",
    hasBottomPadding: true,
  },
  {
    title: "Agentic CDP usage",
    path: "usage",
    variant: "card",
    hasBottomPadding: true,
  },
];

const SETTINGS_NAV_TITLES = new Map([["general", "Configuration"]]);

/** What the settings sidebar, and the page it opens, call an agent settings page. */
export const agentSettingsNavTitle = (tab: DetailPageTab) =>
  SETTINGS_NAV_TITLES.get(tab.path) ?? tab.title;
